import { z } from 'zod';

export const OptionsSchema = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
  amount: z.coerce.number().int().min(0).optional(),
  billingType: z.enum(['perDay', 'perRental']).optional(),
});

export const ExtendedOptionsSchema = z.object({
  options: z.array(OptionsSchema),
});

export type ExtendedOptionsFormData = z.infer<typeof ExtendedOptionsSchema>;
